<button
  (click)="apriModaleInvio()"
  *ngIf="isOnline$ | async"
  [disabled]="inviaVerbaleDisabled$ | async"
  class="btn btn-primary">
  <i class="bi bi-cursor-fill"></i> Invia verbale
</button>

<ngx-smart-modal #sendmodal identifier="modaleinvio" [dismissable]="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-bottom">
        <h5 class="modal-title lh-1 mb-2">Verifica e invia verbale</h5>
      </div>
      <div class="modal-body mt-4 mb-3">
        <p *ngIf="!stampaDisabled">Passo 1: stampa/scarica il verbale da firmare</p>
        <div *ngIf="caricaFile">
          <p>Passo 2: carica e verifica il verbale firmato</p>
          <p>
            <input type="file" id="uploadFile" accept="application/pdf, application/x-pkcs7-mime, .p7m" (change)="fileChange($event)" />
          </p>
        </div>
        <p *ngIf="!inviaDisabled">Passo 3: invia il verbale</p>
      </div>
      <div class="modal-footer justify-content-between border-top pt-2">
        <button type="button" class="btn btn-primary" (click)="stampaVerbale()" [disabled]="stampaDisabled">Stampa</button>
        <button type="button" class="btn btn-primary" (click)="verificaVerbale()" [disabled]="verificaDisabled">Verifica</button>
        <button type="button" class="btn btn-primary" (click)="inviaVerbale()" [disabled]="inviaDisabled">Invia</button>
        <button type="button" class="btn btn-secondary" (click)="chiudiModaleInvio()">Annulla</button>
      </div>
    </div>
  </div>
</ngx-smart-modal>
